module.exports = __webpack_public_path__ + "static/media/pfizer-ireland-pharmaceuticals-ringaskiddy.47add1f3.jpg";